module.exports = __webpack_public_path__ + "img/avon-fighting-breast-cancer-09.212b63e4.jpg";